import React from 'react';
import Navbar from '../components/Navbar.jsx';
import Hero from '../components/hero.jsx';
import { Helmet } from "react-helmet";
import About from '../components/about.jsx';
import ThreeCardSection from '../components/ThreeCardSection.jsx';
import Footer from '../components/footer.jsx';
import DroneGallery from '../components/DroneGallery.jsx';

const Home = () => {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Andrew Snyder Design</title>
        <link rel="canonical" href="http://andrewsnyderdesign.com" />
      </Helmet>
      <Navbar />

      {/* Light section */}
      <section>
        <Hero />
      </section>

      {/* Dark section */}
      <section data-theme="dark">
        <About />
      </section>

      {/* Light section */}
      <section>
        <ThreeCardSection />
      </section>

      {/* Drone Photography Section */}
      {/* No props needed now, the images are inside the component */}
      <section className="bg-white">
        <DroneGallery />
      </section>

      <Footer />
    </div>
  )
};

export default Home;